import {createGettext} from "vue3-gettext";
import translations from "@/language/translations.json";

const languages = {
    'nl': 'nl_BE',
    'fr': 'fr_FR'
}

const gettext = (locale) => {
    return createGettext({
        availableLanguages: {
            nl_BE: "Nederlands",
            fr_FR: "Français"
        },
        defaultLanguage: languages[locale],
        translations: translations,
        silent: true
    });
}

export default gettext;